import { useEffect } from "react";

export function useDocumentTitle(title?: string, description?: string) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;

    let metaEl: HTMLMetaElement | null = null;
    let previousDesc: string | null = null;
    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) {
        previousDesc = metaEl.getAttribute("content");
        metaEl.setAttribute("content", description);
      }
    }

    return () => {
      document.title = previous;
      if (metaEl && previousDesc !== null) {
        metaEl.setAttribute("content", previousDesc);
      }
    };
  }, [title, description]);
}